import {
  DELETE_USER_ACCOUNT_REQUEST,
  DELETE_USER_ACCOUNT_SUCCESS,
  DELETE_USER_ACCOUNT_FAILURE,
  DELETE_USER_ACCOUNT_EMPTY,
} from "../../../Utils/Constant";

const initialState = {
  data: {},
  loading: false,
  error: null,
};
export const deleteUserAccountReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DELETE_USER_ACCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_USER_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case DELETE_USER_ACCOUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_USER_ACCOUNT_EMPTY:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: {},
      };
    default:
      return state;
  }
};
